import React, { Component } from "react";
import {IoIosColorPalette} from 'react-icons/io'
import {BsFillSunFill, BsFillMoonFill} from 'react-icons/bs'

export default class Setting extends Component {
  state = {
    color_windowClass: "setting_wraper",
    i: 0,
    moonTheme: "moon",
    iconsInner: <BsFillSunFill />
  };
  colorWindowHandler = () => {
    if (this.state.color_windowClass === "setting_wraper") {
      this.setState({
        color_windowClass: " setting_wraper setting_wraper_active",
      });
    } else {
      this.setState({ color_windowClass: "setting_wraper" });
    }
  };
  themeHandler = (qiymat) => {
    document.querySelector("body").style = `--colorTheme: ${qiymat};`;
  };
  mooh_theme_handler = () => {
    if (this.state.moonTheme === "moon") {
      localStorage.setItem(
        "colors",
      `--moonTheme: #fff;
      --navBgColor:rgb(30, 30, 30);
      --sectionBgColor: rgb(0, 10, 20);
      --setingIconsColor: #fff;`
      );
      document.querySelector("#root").style = localStorage.getItem('colors');
      this.setState({ moonTheme: "sun" });
      this.setState({ iconsInner:(<BsFillMoonFill />)});
    } else {
      
      localStorage.setItem(
        "colors",
        `
        --moonTheme: #000;
        --navBgColor: #fff9f9;
        --sectionBgColor: #ebf3f2;
        --setingIconsColor: #000;
        `
      );
      document.querySelector("#root").style = localStorage.getItem('colors');
      this.setState({ moonTheme: "moon" });
      this.setState({ iconsInner:(<BsFillSunFill />)});
    }
  };

  render() {
    const { color_windowClass, moonTheme , iconsInner} = this.state;
    const { themeHandler } = this;
    return (
      <div className={color_windowClass}>
        <div className="btnBroup">
          <span onClick={this.colorWindowHandler}>
            <IoIosColorPalette />
          </span>
          <span onClick={this.mooh_theme_handler} className={moonTheme}>
            {iconsInner}
          </span>
        </div>
        <div className="color_window">
          <h3>Theme Color</h3>
          <ul>
            <li
              onClick={() => themeHandler("crimson")}
              className="colorChaneIcon crimson"
            ></li>
            <li
              onClick={() => themeHandler("chocolate")}
              className="colorChaneIcon chocolate"
            ></li>
            <li
              onClick={() => themeHandler("yellowgreen")}
              className="colorChaneIcon yellowgreen"
            ></li>
            <li
              onClick={() => themeHandler("blue")}
              className="colorChaneIcon blue"
            ></li>
            <li
              onClick={() => themeHandler("turquoise")}
              className="colorChaneIcon turquoise"
            ></li>
          </ul>
        </div>
      </div>
    );
  }
}
